



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// ADDCONTACTUSSECTION
// ADDCONTACTUSSECTION


const ADDCONTACTUSSECTION= createAsyncThunk(
  "addContactUsSection/addContactUsSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addContactUsSectionSlice = createSlice({
  name: "addContactUsSectionSlice",
  initialState: {
    addContactUsSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddContactUsSection: (state) => {
        state.addContactUsSection.loading = false
        state.addContactUsSection.error = false
        state.addContactUsSection.data = []
        state.addContactUsSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDCONTACTUSSECTION.fulfilled, (state, action) => {
      state.addContactUsSection = {
        ...state.addContactUsSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDCONTACTUSSECTION.pending, (state, action) => {
      state.addContactUsSection = {
        ...state.addContactUsSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDCONTACTUSSECTION.rejected, (state, action) => {
      state.addContactUsSection = {
        ...state.addContactUsSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addContactUsSectionAction = {
    ADDCONTACTUSSECTION,
};

export { addContactUsSectionAction };
export default addContactUsSectionSlice.reducer;
export const {setInitialStateOfaddContactUsSection} = addContactUsSectionSlice.actions
